import "../../styles/UserDashboard.scss";
import UserDashboardCourseCard from "./UserDashboardCourseCard";
import UserDashboardSectionBanner from "./UserDashboardSectionBanner";
import UserDashboardEmptySection from "./UserDashboardEmptySection";
import UserDashboardBadgeCard from "./UserDashboardBadgeCard";
import useUserEnrollments from "../../Hooks/useFetchUserEnrollments";
import UserDashboardCertificationList from "./UserDashboardCertificationList";

const UserDashboardView = () => {

  const { userBadges, userCompleteEnrollments, userInProgressEnrollments } = useUserEnrollments();

  return (
    <div className="user-dashboard">
      <UserDashboardSectionBanner section="inprogress" />
      {userInProgressEnrollments.length > 0 ? (
        <UserDashboardCourseCard userEnrollments={userInProgressEnrollments} />
      ) : (
        <UserDashboardEmptySection section="inprogress-no-courses" />
      )}

      <UserDashboardSectionBanner section="completed" />
      {userCompleteEnrollments.length > 0 ? (
        <UserDashboardCourseCard userEnrollments={userCompleteEnrollments} />
      ) : (
        <UserDashboardEmptySection section="completed-no-courses" />
      )}

      <UserDashboardSectionBanner section="badges" />
      {userBadges.length > 0 ? (
        <UserDashboardBadgeCard userBadges={userBadges} />
      ) : (
        <UserDashboardEmptySection section="no-badges" />
      )}

      <UserDashboardSectionBanner section="certifications" />
      <UserDashboardCertificationList />
    </div>
  );
};

export default UserDashboardView;